import { render, staticRenderFns } from "./ToReadList.vue?vue&type=template&id=4462230d&"
import script from "./ToReadList.vue?vue&type=script&lang=js&"
export * from "./ToReadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports